import IndividualSavingStatement from "./IndividualSavingStatement";


export default IndividualSavingStatement